// Version : 0.0.2
// Author : AGALYA
// LAST EDIT DONE BY : Shiyam
// LastEdit : Added version
// MODFIED DATA : 23-09-2025

/* eslint-disable import/no-anonymous-default-export */

import overdueReportActionTypes from './over-due-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	overdueReportListResponse: null,
	overdueReportListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET OVERDUE REPORT DETAILS START *********************** */
		case overdueReportActionTypes.GET_OVERDUE_REPORT_LIST_SUCCESS:
			return {
				...state,
				overdueReportListResponse: action.payload,
				overdueReportListArr: docodeHexResponse(action.payload, 'GetoverdueReportKey'),
			};

		case overdueReportActionTypes.GET_OVERDUE_REPORT_LIST_FAILURE:
			return { ...state, overdueReportListResponse: action.payload };

		case overdueReportActionTypes.GET_OVERDUE_REPORT_LIST_RESPONSE_CHANGED:
			return { ...state, overdueReportListResponse: null };
		/** ***************** GET OVERDUE REPORT DETAILS END *********************** */
		default:
			return state;
	}
};
